module.exports = __webpack_public_path__ + "static/media/calendar.2db7b824.svg";